// AdviceNutritionPage.jsx
import React from "react";
import NutritionCalculatorForm from "../../../components/nutrition/NutritionCalculatorForm";

const AdviceNutritionPage = () => {
  // You can pass initial values if needed
  const initialNutritionData = {
    poidsActuel: 70,
    fatPercentage: 20,
    // ...other defaults
  };

  return (
    <NutritionCalculatorForm
      showClientSelection={false}
      initialNutritionData={initialNutritionData}
    />
  );
};

export default AdviceNutritionPage;
